// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Modal } from '@mui/material';
import { AddCash } from './add-cash';
import { type BasePortfolio } from '@shared/data-access/interfaces/common/base-portfolio';
import { CloseButton } from '@shared/ui-kit/components/dynamic-dialog';
import type { Paths } from '@shared/data-access/interfaces/routes/paths';

interface AddCashModalProps {
  dataPortfolio: BasePortfolio;
  openModal: boolean;
  handleClose: () => void;
  to: Paths;
  portfolioName?: string;
}

export const AddCashModal = ({
  dataPortfolio,
  openModal,
  handleClose,
  portfolioName,
  to,
}: AddCashModalProps) => {
  return (
    <Modal open={openModal} sx={{ overflowY: 'scroll' }}>
      <div className="fixed left-[38%] top-[25%] flex max-h-min max-w-[24rem] items-center justify-center rounded-[15px] outline-none after:bottom-[25%]">
        <div className="relative flex w-full items-center justify-between rounded-[8px] bg-white px-4">
          <AddCash
            dataPortfolio={dataPortfolio}
            portfolioName={portfolioName}
            to={to}
          />
          <div className="relative">
            <CloseButton onClick={handleClose} />
          </div>
        </div>
      </div>
    </Modal>
  );
};
